var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpskin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4260_75086)",
    filter: "url(#filter0_i_4260_75086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.896 58.5133C108.517 51.3095 100.88 47.3423 92.3917 47.3423C83.9034 47.3423 76.2661 51.3095 70.8875 58.5133C65.8421 65.2708 63.0635 74.4742 63.0635 84.4284C63.0635 94.3826 65.8421 103.586 70.8875 110.343C76.2661 117.547 83.9034 121.514 92.3917 121.514C100.88 121.514 108.517 117.547 113.896 110.343C118.941 103.586 121.72 94.3826 121.72 84.4284C121.72 74.4742 118.941 65.2708 113.896 58.5133Z",
    fill: "url(#paint0_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6748 58.5133C70.2962 51.3095 62.6591 47.3423 54.1706 47.3423C45.682 47.3423 38.0449 51.3095 32.6663 58.5133C27.6209 65.2708 24.8423 74.4742 24.8423 84.4284C24.8423 94.3826 27.6209 103.586 32.6663 110.343C38.0449 117.547 45.682 121.514 54.1706 121.514C62.6591 121.514 70.2962 117.547 75.6748 110.343C80.7202 103.586 83.4988 94.3826 83.4988 84.4284C83.4988 74.4742 80.7202 65.2708 75.6748 58.5133Z",
    fill: "url(#paint1_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7855 58.5133C89.4069 51.3095 81.7696 47.3423 73.2813 47.3423L56.252 84.4284L73.2813 121.514C81.7696 121.514 89.4069 117.547 94.7855 110.343C99.8307 103.586 102.61 94.3826 102.61 84.4284C102.61 74.4742 99.8307 65.2708 94.7855 58.5133Z",
    fill: "url(#paint2_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7772 58.5133C46.7317 65.2708 43.9531 74.4742 43.9531 84.4284C43.9531 94.3826 46.7317 103.586 51.7772 110.343C57.1558 117.547 64.7928 121.514 73.2814 121.514V47.3423C64.7928 47.3423 57.1558 51.3095 51.7772 58.5133Z",
    fill: "url(#paint3_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7535 30.9825C66.6676 28.1586 61.9723 30.4699 59.8942 30.3311C58.5658 30.2431 56.6929 29.481 54.5716 26.2495C53.5684 28.715 53.7029 31.5925 54.9302 33.9449C56.1576 36.2972 58.2675 38.219 60.8905 38.8549C62.9851 39.3627 64.7582 38.6936 67.0584 39.4185C69.4386 40.1689 71.16 42.3308 71.8089 44.5619C72.0059 44.0691 73.12 41.6266 73.4958 38.8305C73.8717 36.0345 73.509 32.8866 70.7535 30.9825Z",
    fill: "url(#paint4_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2422 31.5587C56.2434 31.6255 57.9183 32.8636 62.1878 32.1875C66.8353 31.4525 69.3679 31.4489 70.8419 33.2375C72.225 34.9156 72.4705 39.4492 72.1203 41.7865C72.1035 41.6313 70.8782 38.7484 66.0897 38.2001C62.8256 37.8253 60.3781 37.0327 58.7403 35.8989C57.1023 34.7667 56.2723 33.2931 56.2422 31.5587Z",
    fill: "url(#paint5_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9891 34.5244C61.9946 34.5565 62.9094 35.0576 64.9765 34.4387C67.2257 33.7652 68.4785 33.5944 69.3331 34.3804C70.134 35.1172 70.5726 37.3416 70.5615 38.5188C70.5416 38.4427 69.735 37.101 67.3268 37.1483C65.685 37.1811 64.4189 36.9521 63.5292 36.5021C62.6379 36.0519 62.1248 35.3792 61.9891 34.5244Z",
    fill: "url(#paint6_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3637 36.1884C55.4146 37.9585 58.2768 41.517 63.8095 40.6974C67.0533 40.2171 70.259 41.6932 71.8463 44.4901L71.9017 44.5877C68.6882 40.7684 60.3363 47.3279 54.3637 36.1884Z",
    fill: "url(#paint7_linear_4260_75086)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4260_75086)",
    filter: "url(#filter1_i_4260_75086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.412 101.424C141.869 96.4266 138.456 92.7624 133.803 91.1069C129.151 89.4513 124.19 90.1364 119.837 93.0362C115.753 95.7562 112.435 100.259 110.494 105.716C108.552 111.172 108.28 116.759 109.728 121.447C111.271 126.445 114.684 130.109 119.337 131.765C123.99 133.42 128.95 132.735 133.303 129.835C137.387 127.115 140.705 122.612 142.647 117.156C144.588 111.699 144.86 106.113 143.412 101.424Z",
    fill: "url(#paint8_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.461 93.9699C120.918 88.9721 117.505 85.3079 112.852 83.6523C108.199 81.9967 103.239 82.6818 98.8859 85.5816C94.8022 88.3016 91.4841 92.8046 89.5427 98.261C87.6012 103.717 87.3293 109.304 88.777 113.992C90.3203 118.99 93.7328 122.654 98.3859 124.31C103.039 125.966 107.999 125.28 112.352 122.381C116.436 119.661 119.754 115.158 121.695 109.701C123.637 104.245 123.909 98.658 122.461 93.9699Z",
    fill: "url(#paint9_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.937 97.6971C131.393 92.6993 127.981 89.035 123.328 87.3795L106.76 104.387L108.861 128.037C113.514 129.693 118.475 129.008 122.828 126.108C126.911 123.388 130.23 118.885 132.171 113.428C134.112 107.972 134.384 102.385 132.937 97.6971Z",
    fill: "url(#paint10_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.361 89.3089C105.278 92.0289 101.96 96.5319 100.018 101.988C98.0768 107.445 97.8049 113.032 99.2526 117.72C100.796 122.718 104.208 126.382 108.861 128.037L123.328 87.3796C118.675 85.724 113.715 86.4091 109.361 89.3089Z",
    fill: "url(#paint11_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.133 77.9191C123.444 75.5743 120.419 75.9254 119.307 75.444C118.596 75.1367 117.718 74.3537 117.186 72.1685C116.155 73.3244 115.668 74.9279 115.882 76.4568C116.096 77.9856 116.877 79.4506 118.191 80.3107C119.24 80.9976 120.343 80.9766 121.462 81.8226C122.62 82.6982 123.142 84.219 123.063 85.5685C123.267 85.3368 124.354 84.2152 125.106 82.7559C125.857 81.2965 126.272 79.5003 125.133 77.9191Z",
    fill: "url(#paint12_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.066 75.4047C117.054 75.4415 117.731 76.4468 120.203 76.909C122.894 77.4125 124.283 77.9045 124.742 79.1724C125.173 80.362 124.423 82.8951 123.775 84.1079C123.796 84.0196 123.687 82.2003 121.169 80.9658C119.453 80.1238 118.266 79.2119 117.589 78.271C116.912 77.3309 116.745 76.3613 117.066 75.4047Z",
    fill: "url(#paint13_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.638 78.1513C119.635 78.17 120.038 78.6231 121.292 78.687C122.656 78.7565 123.376 78.9073 123.692 79.5048C123.987 80.0649 123.793 81.3697 123.558 82.0128C123.562 81.9673 123.381 81.0745 122.052 80.6307C121.146 80.3285 120.496 79.956 120.096 79.5358C119.696 79.1152 119.545 78.6464 119.638 78.1513Z",
    fill: "url(#paint14_linear_4260_75086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.134 77.5761C115.364 78.7514 116.239 81.2602 119.432 81.8901C121.304 82.2594 122.773 83.6938 123.098 85.5365L123.109 85.6008C122.092 82.8805 116.235 84.8472 115.134 77.5761Z",
    fill: "url(#paint15_linear_4260_75086)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4260_75086",
    x: 20,
    y: 20,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.138158 0 0 0 0 0.142105 0 0 0 0 0.161842 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4260_75086"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4260_75086",
    x: 78,
    y: 62,
    width: 81.751,
    height: 81.7512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.138158 0 0 0 0 0.142105 0 0 0 0 0.161842 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4260_75086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4260_75086",
    x1: 63.0635,
    y1: 84.4284,
    x2: 121.72,
    y2: 84.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#F77D51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4260_75086",
    x1: 35.4687,
    y1: 84.4284,
    x2: 123.125,
    y2: 84.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF918A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4260_75086",
    x1: 56.252,
    y1: 84.4284,
    x2: 102.61,
    y2: 84.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4260_75086",
    x1: 43.9531,
    y1: 84.4284,
    x2: 73.2814,
    y2: 84.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4260_75086",
    x1: 69.9264,
    y1: 29.7364,
    x2: 59.139,
    y2: 39.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4260_75086",
    x1: 69.7479,
    y1: 31.9877,
    x2: 61.4294,
    y2: 39.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7342B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4260_75086",
    x1: 65.8279,
    y1: 33.8053,
    x2: 66.8414,
    y2: 39.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00512821,
    stopColor: "#FF9803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FAF154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4260_75086",
    x1: 66.1936,
    y1: 37.8119,
    x2: 59.9469,
    y2: 43.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4260_75086",
    x1: 110.494,
    y1: 105.716,
    x2: 142.647,
    y2: 117.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#F77D51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4260_75086",
    x1: 95.3676,
    y1: 100.334,
    x2: 143.417,
    y2: 117.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF918A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4260_75086",
    x1: 106.76,
    y1: 104.387,
    x2: 132.171,
    y2: 113.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4260_75086",
    x1: 100.018,
    y1: 101.988,
    x2: 116.095,
    y2: 107.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4260_75086",
    x1: 124.923,
    y1: 77.0747,
    x2: 117.163,
    y2: 80.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4260_75086",
    x1: 124.386,
    y1: 78.2739,
    x2: 118.403,
    y2: 80.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7342B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4260_75086",
    x1: 121.882,
    y1: 78.5059,
    x2: 121.383,
    y2: 81.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00512821,
    stopColor: "#FF9803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FAF154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4260_75086",
    x1: 121.302,
    y1: 80.7733,
    x2: 116.808,
    y2: 82.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4260_75086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(20 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4260_75086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(99.4541 62) rotate(19.586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpskin);
export default __webpack_public_path__ + "static/media/Pumpskin.079ca5e7895104e63e0200ea2871cdc9.svg";
export { ForwardRef as ReactComponent };